<ng-template [ngIf]="shouldRender">
  <p
    class="mobile-apps-badges_caption"
    *transloco="let t">
    {{ t('mobile-apps-badges.caption') }}
  </p>

  <div class="mobile-apps-badges_links">
    <a
      target="_blank"
      href="https://play.google.com/store/apps/details?id=com.firstbird.mobile">
      <img
        alt="Get it on Google Play"
        src="/assets/images/project/google-badge.svg" />
    </a>
    <a
      target="_blank"
      href="https://itunes.apple.com/us/app/id1168024075">
      <img
        alt="Download on the App Store"
        src="/assets/images/project/appstore-badge.svg" />
    </a>
  </div>
</ng-template>
